export const genderDirector = ['MALE', 'FEMALE']

export const religionDirector = [
  'ISLAM',
  'KATHOLIK',
  'KRISTEN',
  'BUDHA',
  'HINDU',
  'KONGHUCU',
  'OTHER'
]

export const marriageDirector = ['KAWIN', 'BELUM KAWIN', 'CERAI MATI', 'CERAI HIDUP']

export const educationDirector = [
  'SD / Elementary School',
  'SMP / Junior High School',
  'SMA / High School',
  'Diploma Degree (D1/D2/D3)',
  'S1 / Bachelor Degree',
  'S2 / Master Degree',
  'S3 / Doctorate Degree'
]

export const jobDirector = [
  'Pilot',
  'Notaris',
  'Arsitek',
  'Akuntan',
  'Konsultan',
  'Dokter',
  'Bidan',
  'Perawat',
  'Apoteker',
  'Psikiater/ Psikolog',
  'Penyiar Televisi',
  'Penyiar Radio',
  'Pelaut',
  'Peneliti',
  'Sopir',
  'Pialang',
  'Pedagang',
  'Biarawati',
  'Wiraswasta',
  'Pewagai Negeri Sipil',
  'Petani/ Pekebun',
  'Peternak',
  'Nelayan/ Perikanan',
  'Lainnya'
]

export const positionDirector = ['DIRECTOR', 'VICE DIRECTOR', 'MANAGER', 'COMMISIONER']

export const otherIncomeDirector = [
  'BUSINESS REVENUE',
  'FUND REVENUE',
  'INHERITANCE',
  'SALARY',
  'PARENT/GUARDIAN'
]

export const houseOwnerShipDirector = [
  'FAMILY/KELUARGA',
  'PARENT/ORANG TUA',
  'RENTAL/KOS',
  'OWNED/MILIK SENDIRI',
  'OFFICE RESIDENCE/RUMAH DINAS'
]

export const liveDurationDirector = ['< 1', '1 - 3', '3 - 5', '> 5']
